import { useState } from "react";
import { Box } from "@mui/material";
import AppModal from "../../common/AppModal";
import AppSnackbar from "../../common/AppSnackbar";
import ToolbarButton from "../../common/Toolbar-button";
import AddCategoryModal from "./category-add-model";
import usePermissions from "../../../hooks/usePermissions";

interface IProps {
  getCategory: () => void;
  openModal: any;
  setOpenModal: any;
  editedBoolen: any;
  editCategoryData: any;
  setEditedBoolen: any;
  setEditCategoryData: any;
  filteredRowData: any;
}

export const CategoryToolbar = ({
  getCategory,
  openModal,
  setOpenModal,
  editedBoolen,
  editCategoryData,
  setEditedBoolen,
  setEditCategoryData,
  filteredRowData,
}: IProps) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [editSuccess, setEditSuccess] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const isPermissions = usePermissions();
  const Account_Type = parseInt(localStorage.getItem("pharmacy_account_type") || "0", 10);

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditedBoolen(false);
    setEditCategoryData(null);
  };

  return (
    <>
      {(isPermissions?.add && Account_Type === 1) || Account_Type === 0 ? (
        <Box
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            py: 2,
          }}
        >
          <ToolbarButton
            title={"Add New Category"}
            handleOpenModal={handleOpenModal}
          />
        </Box>
      ) : null}

      <AppModal
        title={editedBoolen ? "Edit Category" : "Add New Category"}
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        //  height="500px"
      >
        <AddCategoryModal
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          getCategory={getCategory}
          editCategoryData={editCategoryData}
          editedBoolen={editedBoolen}
          setEditSuccess={setEditSuccess}
          filteredRowData={filteredRowData}
        />
      </AppModal>
      <AppSnackbar
        message={editSuccess ? "Successfully Updated!" : "Successfully Added!"}
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      />
    </>
  );
};
